import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
    show: boolean;
    title: string;
    description: string;
}

// Initial state for the error
const initialState: InitialState = {
    // Flag for show error
    show: false,
    // stores title of an error
    title: '',
    // stores description of an error
    description: ''
};

// Creating the error slice with initial state and reducers
const errorSlice = createSlice({
    // slice name
    name: 'error',
    // inital state for the slice
    initialState,
    reducers: {
        // show error with title and descriptions
        showError: (state, action) => {
            state.show = true;
            state.title = action.payload?.title ? action.payload?.title : 'Error';
            state.description = action.payload?.description
                ? action.payload?.description
                : 'Something went wrong';
        },
        // hide error as well as title and description
        hideError: (state) => {
            state.show = false;
            state.title = '';
            state.description = '';
        },
        // Resets the entire state to the initial values
        resettingError: () => {
            return initialState;
        }
    }
});

// Exporting action creators generated by createSlice for data
export const { showError, hideError, resettingError } = errorSlice.actions;

// Exporting the reducer to use in the root reducer
export default errorSlice.reducer;
